// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
import Hero from "types/fields/entries/hero";
// MARK: Components
import Typography from "components/common/typography";
// MARK: Utils
import Media from "utils/common/media";
import CSSStyles from "enums/cssStyles";

// MARK: Styled Components
interface WrapperProps {
    maxWidth?: number;
    marginTop: number;
    height: string;
  }
  
  const Wrapper = styled.div<WrapperProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${({ height }) => height};
    margin-top: ${({ marginTop }) => marginTop}px !important;
    margin: auto;
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth + "px" : "")};
    border-radius: 0px;
    background-color: transparent;
    overflow: hidden;
  `;

interface BlogPostHeroType {
    hero: Hero
    blogHeroSubtitle: string
}

const BlogPostHero = ({ hero, blogHeroSubtitle } : BlogPostHeroType) => {
      // Mark: React Redux Variables
    const styleguide: ReduxStyleguide = useSelector(
        (state: RootState) => state.styleguide
    );
    const {
        containerWidth,
        maximumBlogWidth,
        margin,
        colors
      } = styleguide;
      const layoutWidth =
    containerWidth > maximumBlogWidth ? maximumBlogWidth : containerWidth;
      const imageWidth =
      layoutWidth > containerWidth
        ? containerWidth
        : layoutWidth + (containerWidth - layoutWidth) / 2;
    return (
        <Wrapper height={"auto"} marginTop={margin}>
        <Wrapper height={"auto"} marginTop={margin} maxWidth={imageWidth}>
            <Media hero={hero} borderradius={20} />
        </Wrapper>
        <Typography
            marginTop={margin}
            className={CSSStyles.bodyBold}
            color={colors.primary}
            dangerouslySetInnerHTML
        >
            {blogHeroSubtitle}
        </Typography>
        </Wrapper>
    );
};

export default BlogPostHero